import { renderStatusCell } from 'ui/table/StatusCell';

export const TransactionStatusCell = renderStatusCell({
    COMPLETED: 'green',
    PENDING: 'yellow',
    DECLINED: 'red',
    DISPUTED: 'red'
});
